import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { STATES } from "../../../components/oems/helper";

export const HeaderConfig = [
  {
    label: "OEM",
    id: "oemOrg",
    render: (data) => <span>{data?.oemOrg?.name}</span>,
  },
  {
    label: "Complaint Reported Date",
    id: "complaintReportedDate",
    render: (data) => {
      return (
        <span>
          {data?.complaintReportedDate &&
            moment(data.complaintReportedDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "Engine No.",
    id: "engineNo",
  },
  {
    label: "List Number",
    id: "listNumber",
  },
  {
    label: "Engine Model",
    id: "engineModel",
  },
  {
    label: "Action Code",
    id: "actionCode",
    render: (data) => <span>{data?.actionCode?.code}</span>,
  },
  {
    label: "Action Taken",
    id: "actionTaken",
  },
  {
    label: "Application",
    id: "application",
  },
  {
    label: "Country",
    id: "country",
  },
  {
    label: "Location",
    id: "location",
  },
  {
    label: "Complaint Code",
    id: "complaintCode",
    render: (data) => <span>{data?.complaintCode?.code}</span>,
  },
  {
    label: "Complaint Description",
    id: "complaintDescription",
  },
  {
    label: "Defect Code",
    id: "defectCode",
    render: (data) => <span>{data?.defectCode?.code}</span>,
  },
  {
    label: "Defect Description",
    id: "defectDescription",
  },
  {
    label: "Invoice Date",
    id: "invoiceDate",
    render: (data) => {
      return (
        <span>
          {data?.invoiceDate && moment(data.invoiceDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },

  {
    label: "HMR",
    id: "hmr",
  },
  { label: "Machine Model", id: "machineModel" },
  {
    label: "Sale Date",
    id: "saleDate",
    render: (data) => {
      return (
        <span>
          {data?.saleDate && moment(data.saleDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },

  {
    label: "OEM Service Eng.",
    id: "oemSe",
  },
  {
    label: "Plant",
    id: "plant",
  },
  {
    label: "Remarks",
    id: "remarks",
  },
  {
    label: "ECN Details",
    id: "ecnDetails",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton>
          <DeleteIcon color="error" onClick={() => onClick("DELETE", data)} />
        </IconButton>
      </Box>
    ),
  },
];
export const getClaimFormConfig = (
  complaintCodes = [],
  defectCodeList = [],
  actionCodeList = [],
  oemList = []
) => [
  {
    name: "oemOrg",
    type: "autocomplete",
    label: "OEM Org",
    placeholder: "Enter OEM",
    options: oemList,
    required: true,
  },
  {
    name: "complaintReportedDate",
    type: "datePicker",
    label: "Complaint Reported Date",
    placeholder: "Complaint Reported Date",
    required: true,
  },
  {
    name: "engineNo",
    type: "text",
    label: "Engine No.",
    placeholder: "Enter Engine Number",
    required: true,
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Enter Engine Model",
    required: true,
  },

  {
    name: "listNumber",
    type: "text",
    label: "List Number",
    placeholder: "Engine List Number",
    required: true,
  },
  {
    name: "machineModel",
    type: "text",
    label: "Machine Model",
    placeholder: "Machine Model",
    required: true,
  },
  {
    name: "oemSe",
    type: "text",
    label: "Oem Service Engineer",
    placeholder: "Enter OEM SE",
    required: true,
  },
  {
    name: "plant",
    type: "text",
    label: "Plant",
    placeholder: "Plant",
    required: true,
  },
  {
    name: "invoiceDate",
    type: "datePicker",
    label: "Invoice Date",
    placeholder: "Invoice Date",
    required: true,
  },
  {
    name: "saleDate",
    type: "datePicker",
    label: "Sale Date",
    placeholder: "Sale Date",
    required: true,
  },
  {
    name: "hmr",
    type: "text",
    label: "HMR",
    placeholder: "Enter HMR",
    required: true,
  },
  {
    name: "country",
    type: "text",
    label: "Country",
    placeholder: "Enter Country",
    required: true,
  },

  {
    name: "location",
    type: "text",
    label: "Location",
    placeholder: "Location",
    required: true,
  },
  {
    name: "complaintCode",
    type: "autocomplete",
    options: complaintCodes,
    label: "Complaiint",
    placeholder: "Nature Of Complaint",
    required: true,
  },
  {
    name: "application",
    type: "text",
    label: "Application",
    placeholder: "Application",
    required: true,
  },
  {
    name: "defectCode",
    type: "autocomplete",
    options: defectCodeList,
    label: "Defect Description",
    placeholder: "Select Defect",
    required: true,
  },
  {
    name: "actionCode",
    type: "autocomplete",
    options: actionCodeList,
    label: "Action Code",
    placeholder: "Select Action",
    required: true,
  },
  {
    name: "complaintStatus",
    type: "text",
    label: "Complaint Status",
    placeholder: "Complaint Status",
    required: true,
  },
  {},
  {},
  {
    name: "remarks",
    type: "textarea",
    label: "Remarks",
    placeholder: "Remarks",
    fieldGridSize: 6,
  },
  {
    name: "ecnDetails",
    type: "textarea",
    label: "ECN Details (if Any)",
    placeholder: "ECN Details",
    fieldGridSize: 6,
  },
];
